// 9fbef606107a605d69c0edbcd8029e5de
import { getPLPProductAttributes, extractAttributeValue } from '@tcp/core/src/utils/badge.util';
import { getImageAssetConfig } from '../../../features/browse/PlpTile/views/plpTileHelpers/plpTileCommonHelpers';

const collectSimilarProductData = ({
  product,
  imageUrl,
  primaryBrand,
  isShortImage = false,
  apiConfig,
  TCPPrimaryCategory,
}) => {
  const {
    product_name: name,
    TCPBazaarVoiceRating,
    TCPCustomSalePrice,
    TCPCustomListPrice,
    min_offer_price: minOfferPrice,
    min_list_price: minListPrice,
    low_offer_price: lowOfferPrice,
    low_list_price: lowListPrice,
    high_offer_price: highOfferPrice,
    high_list_price: highListPrice,
    productid: productPartNo,
    seo_token: seoToken,
    TCPColor,
  } = product;

  const { assetHost, assetPath } = getImageAssetConfig(primaryBrand.toLowerCase(), apiConfig);
  const attributes = getPLPProductAttributes();
  const merchantTag = extractAttributeValue(product, attributes.merchant);

  return {
    name,
    primaryBrand,
    uniqueId: product.uniqueId,
    productPartNo,
    seoToken,
    imageUrl,
    assetHost,
    assetPath,
    TCPPrimaryCategory,
    ratings: TCPBazaarVoiceRating,
    listPrice: TCPCustomListPrice || minListPrice,
    offerPrice: TCPCustomSalePrice || minOfferPrice,
    priceRange: {
      lowOfferPrice,
      highOfferPrice,
      lowListPrice,
      highListPrice,
    },
    TCPColor,
    merchantTag,
    imagesByColor: {
      [TCPColor]: {
        basicImageUrl: imageUrl,
        extraImages: [
          {
            isShortImage,
            iconSizeImageUrl: imageUrl,
            listingSizeImageUrl: imageUrl,
            regularSizeImageUrl: imageUrl,
            bigSizeImageUrl: imageUrl,
            superSizeImageUrl: imageUrl,
          },
        ],
      },
    },
  };
};

export default collectSimilarProductData;
